var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-check form-check-custom form-check-sm"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value.includes(_vm.data)},on:{"change":_vm.toggle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }